/**
 * @export
 * @class Template
 * 템플릿을 반환하는 함수를 관리하는 객체
 */
export default class Template {
  /**
   * 옵션 남은 수량과 매진임박 메시지 템플릿
   * @param htItem : dealInfo 의 option item 정보. 외부 정보이기 때문에 여기서는 htItem 의 구성요소를 명시하지 않음
   * @returns {*}
   */
  getStockCount = (htItem) => {
    if (htItem.orderDealMax.soldOut) {
      // 매진이면 수량을 노출하지 않는다.
      return "";
    }

    if (TMON.oApp.htStorage.htStaticData.htCustomDealInfo.bCustomDeal) {
      // 커스텀딜에서는 다른 로직과 상관없이 잔여수량 노출 안함. 매진임박도 노출 못함.
      return "";
    }

    if (
      !htItem.orderDealMax ||
      isNaN(htItem.orderDealMax.stockCount) ||
      htItem.orderDealMax.stockCount < 1
    )
      return "";

    const stockCount =
      htItem.orderDealMax.stockCount > 99
        ? "99+"
        : htItem.orderDealMax.stockCount;
    let stockCountClassName = "stock";
    if (htItem.orderDealMax.showSoldOutSoon) {
      stockCountClassName = "soonout";
    } else if (TMON.oApp.sPlatform !== "PW") {
      stockCountClassName = "qty";
    }

    const stockHtml = `<span class="${stockCountClassName}">
      ${
        htItem.orderDealMax.showSoldOutSoon
          ? `매진 임박(${stockCount}개 남음)`
          : `${stockCount}개 남음`
      }
    </span>`;

    const isPc = TMON.oApp.sPlatform === "PW";
    return isPc ? `<span>${stockHtml}</span>` : stockHtml;
  };

  /**
   * 연관딜 (슈퍼클릭 / 본본 / 같은카테고리 인기상품) 의 가격 타입 텍스트
   * @param ht : 해당 아이템의 정보. 외부 정보이기 때문에 여기서는 ht 의 구성요소를 명시하지 않음
   * @returns {*}
   */
  getInterGratedDealsPriceType = (ht) => {
    const htDiscountInfos = TMON.oApp.oUtil.getDiscountInfos(ht);
    const avgHtml = htDiscountInfos.isHideReview
      ? ""
      : this.getAverage(htDiscountInfos.userPoint);

    const sHtml = `
            <div class="price_info" data-testcode="${
              htDiscountInfos.sTestCodeOnPriceDefinitionList
            }">
                ${
                  htDiscountInfos.sVisibleDiscountInfo !== "none"
                    ? `<p class="deal_type">
                        ${
                          htDiscountInfos.sVisibleDiscountInfo ===
                          "discountRate"
                            ? `<span class="tmon_sale">${
                                htDiscountInfos.discountRate
                              }%</span>`
                            : ""
                        }
                        ${
                          htDiscountInfos.sVisibleDiscountInfo ===
                          "discountLabel"
                            ? `<span class="tmon_sale">${
                                htDiscountInfos.discountLabel
                              }</span>`
                            : ""
                        }
                        ${
                          htDiscountInfos.sVisibleDiscountInfo === "균일가"
                            ? '<span class="tmon_sale">균일가</span>'
                            : ""
                        }
                    </p>`
                    : ""
                }
                <p class="price_selling">
                    ${
                      !isNaN(htDiscountInfos.price)
                        ? `
                        <span>${TMON.util.numberWithComma(
                          htDiscountInfos.price
                        )}원${
                            htDiscountInfos.isVisibleDelegatePriceOver
                              ? "~"
                              : ""
                          }</span>
                    `
                        : ""
                    }
                    ${
                      htDiscountInfos.isVisibleOriginalPrice === true
                        ? `
                        <span class="price_reduced">${
                          htDiscountInfos.originalPrice
                        }원</span>
                    `
                        : ""
                    }
                    </p>
                </div>
                ${avgHtml}`;
    return sHtml;
  };

  /**
   *
   * 딜 추천영역 별점&후기 반환
   * @param userPoint {reviewCount(후기 갯수), reviewAverage(평점)}
   * @return string
   */

  getAverage = (userPoint) => {
    const { reviewCount, reviewAverage } = userPoint;
    let [naturalNum, decimalNum] = reviewAverage.toString().split(".");
    naturalNum = Number(naturalNum);
    decimalNum = Number(decimalNum);
    const html = `
    ${TMON.oApp.sPlatform !== "PW" ? '<div class="deallist_scroll_grade">' : ""}
      <div class="grade_average" aria-label="구매후기 5점 만점 중 ${reviewAverage}점 ${reviewCount}명 참여">
        <div class="grade_average_points" tabindex="-1">
        ${this.makeStarPoint(naturalNum, decimalNum)}
        </div >
        ${reviewCount > 0 && this.makeReviewCount(reviewCount)}
      </div>
    ${TMON.oApp.sPlatform !== "PW" ? "</div>" : ""}
      `;
    return html;
  };

  /**
   * 후기 갯수 그리기
   */
  makeReviewCount = (reviewCount) => {
    let html = "";
    /* ReviewCount(후기)가 0보다 클때 후기 갯수를 보여줌 */
    html += `
      <span class="grade_average_count" tabindex="-1">
          <span class="num">${reviewCount}</span>
      </span>`;
    return html;
  };

  /**
   * 별점 그린 후 반환 nautralNum 값이 있을 경우만 색칠 0일때 X
   */
  makeStarPoint = (naturalNum = 0, decimalNum) => {
    let html = "";
    let decimalCheck = true;
    for (let i = 0; i < 5; i++) {
      let markNum = 0;
      if (naturalNum) {
        if (naturalNum >= i + 1) {
          markNum = 10;
        } else if (decimalCheck) {
          markNum = decimalNum;
          decimalCheck = false;
        }
      }
      html += `<span class="grade_average_point">
        <span class="grade_average_mark mark_${markNum}0"></span>
      </span>`;
    }

    return html;
  };

  /**
   * 딜 추천영역 마스크를 반환한다.
   *
   * @param item: intergratedDeals
   */
  getMasking(item) {
    const { dealMax, contentsLevel } = item;
    let mask = "";
    let maskText = "";

    if (dealMax && dealMax.soldOut) {
      mask = "sold_out";
      maskText = "매진";
    } else if (
      (contentsLevel === "TOP" || contentsLevel === "MIDDLE") &&
      !TMON.oApp.htStorage.htStaticData.isAdultCert
    ) {
      mask = "adult_only";
      maskText = "미성년자 열람 제한";
    }

    return `
          <div class="mask ${mask}">
            <div class="mask_bg"></div>
            <div class="mask_info">
              <span class="text">${maskText}</span>
            </div>
          </div>
        `;
  }
}
